const text = {
  zh: {
    greeting: 'Hello from zh'
  }
};

exports.default = text;